import { ModelPageType } from "lib/types/assets/ModelPageType";

/**
 * A model type tab's Models panel and every page under it, including a model
 * or element picked in the 3D view, so the tab stays lit and remembers the
 * selection to come back to.
 */
function modelTypeRoute(pageType: ModelPageType) {
  const id = String.raw`(?:\d+|\[\w+\])`;
  return {
    href: {
      pathname: "/projects/[projectId]/[assetPageType]",
      query: { assetPageType: pageType },
    },
    regex: new RegExp(String.raw`^\/projects\/${id}\/${pageType}(?:[\/?#]|$)`),
  };
}

export const routesDefinitions = {
  projects: {
    href: {
      pathname: "/projects",
    },
    regex: /^\/projects\/?$/,
  },
  projectsCreate: {
    href: {
      pathname: "/projects/create",
    },
    regex: /^\/projects\/create\/?$/,
  },
  project: {
    href: {
      pathname: "/projects/[projectId]",
    },
    regex: /^\/projects\/(?:\d+|\[\w+\])\/?$/,
  },
  projectSettings: {
    href: {
      pathname: "/projects/[projectId]/settings",
    },
    regex: /^\/projects\/(?:\d+|\[\w+\])\/settings\/?/,
  },
  projectTransferBegin: {
    href: {
      pathname: "/projects/transfer/[projectTransferId]/begin",
    },
    regex: /^\/projects\/transfer\/(?:\d+|\[\w+\])\/begin\/?$/,
  },
  projectTransferAccept: {
    href: {
      pathname: "/projects/transfer/[projectTransferId]/accept",
    },
    regex: /^\/projects\/transfer\/(?:\d+|\[\w+\])\/accept\/?$/,
  },
  layers: {
    href: {
      pathname: "/projects/[projectId]/layers",
    },
    regex: /^\/projects\/(?:\d+|\[\w+\])\/layers/,
  },
  layerCriteria: {
    regex: /^\/projects\/(?:\d+|\[\w+\])\/layers\/(?:\d+|\[\w+\])\/criteria\/?/,
  },
  views: {
    href: {
      pathname: "/projects/[projectId]/views",
    },
    regex: /^\/projects\/(?:\d+|\[\w+\])\/views/,
  },
  assetPages: {
    regex:
      /^\/projects\/(?:\d+|\[\w+\])\/\[assetPageType\](?!\/(?:\d+|(?:(?:\d+|\[\w+\])\/versions\/(?:\d+|\[\w+\])\/elements\/(?:[\d\w]+|\[\w+\]))))/,
  },
  models: modelTypeRoute("models"),
  scans: modelTypeRoute("scans"),
  gis: modelTypeRoute("gis"),
  imagery: modelTypeRoute("imagery"),
  selectedAsset: {
    href: {
      pathname:
        "/projects/[projectId]/[assetPageType]/[assetId]/versions/[versionId]/selected",
    },
    regex:
      /^\/projects\/(?:\d+|\[\w+\])\/(?:models|scans|gis|imagery|other|layers|\[assetPageType\])\/(?:\d+|\[\w+\])\/versions\/(?:\d+|\[\w+\])\/selected/,
  },
  modelElement: {
    href: {
      pathname:
        "/projects/[projectId]/[assetPageType]/[assetId]/versions/[versionId]/elements/[elementId]",
    },
    regex:
      /^\/projects\/(?:\d+|\[\w+\])\/(?:models|scans|gis|imagery|other|layers|\[assetPageType\])\/(?:\d+|\[\w+\])\/versions\/(?:\d+|\[\w+\])\/elements\/(?:[\d\w]+|\[\w+\])/,
  },
  modelElementProperties: {
    href: {
      pathname:
        "/projects/[projectId]/[assetPageType]/[assetId]/versions/[versionId]/elements/[elementId]/properties",
    },
    regex:
      /^\/projects\/(?:\d+|\[\w+\])\/(?:models|scans|gis|imagery|other|layers|\[assetPageType\])\/(?:\d+|\[\w+\])\/versions\/(?:\d+|\[\w+\])\/elements\/(?:[\d\w]+|\[\w+\])\/properties/,
  },
  search: {
    href: {
      pathname: "/projects/[projectId]/search",
    },
    regex: /^\/projects\/(?:\d+|\[\w+\])\/search/,
  },
  issues: {
    href: {
      pathname: "/projects/[projectId]/issues",
    },
    regex: /^\/projects\/(?:\d+|\[\w+\])\/issues/,
  },
  members: {
    href: {
      pathname: "/projects/[projectId]/members",
    },
    regex: /^\/projects\/(?:\d+|\[\w+\])\/members/,
  },
  workspacesCreate: {
    href: {
      pathname: "/workspaces/create",
    },
    regex: /^\/workspaces\/create\/?$/,
  },
  workspacesSettings: {
    href: {
      pathname: "/workspaces/[workspaceId]/settings",
    },
    regex: /^\/workspaces\/(?:\d+|\[\w+\])\/settings\/?/,
  },
  workspacePaywall: {
    href: {
      pathname: "/workspaces/[workspaceId]/paywall",
    },
    regex: /^\/workspaces\/(?:\d+|\[\w+\])\/paywall\/?$/,
  },
  auth: {
    regex: /^\/auth\/?/,
  },
  invitesForm: {
    regex: /^\/register\/invites\/(?:\d+|\[\w+\])\/account$/,
  },
  invites: {
    regex: /^\/register\/invites\/(?:\d+|\[\w+\])\//,
  },
  registerForm: {
    regex: /^\/register$/,
  },
  register: {
    href: {
      pathname: "/register",
    },
    regex: /^\/register\/?/,
  },
  accountSettings: {
    href: {
      pathname: "/accounts/settings",
    },
    regex: /^\/accounts\/settings\/?/,
  },
} as const;
